import {modules, services} from "../../engines/gameEngine";
import {REWARD_TYPE} from "../../engines/services/userContent/userInterface";
import data_control from "../../engines/libs/data_control";
import PageBase from "../../engines/modules/uiModule/PageBase";
import { IAddUserPropPrams, IPagePramsBase } from "../../engines/modules/uiModule/UIPrams";
import utilsModel from "../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class addUserProp extends PageBase {

    @property(cc.Node)
    detail: cc.Node = null;
    @property(cc.Label)
    title: cc.Label = null;
    @property(cc.Label)
    protected showNum: cc.Label = null;
    @property(cc.Sprite)
    protected spIcon: cc.Sprite = null;
    @property([cc.SpriteFrame])
    protected spfIcons: cc.SpriteFrame[] = [];

    // LIFE-CYCLE CALLBACKS:
    // protected onLoad() {
    // }

    // protected start(): void {
    //     this.initView();
    // }
    protected m_prams: IAddUserPropPrams = null;

    async OnPageOpen(prams?: IAddUserPropPrams) {
        super.OnPageOpen(prams);
        this.setData(this.m_prams.propType,this.m_prams.propNumber);
        this.initView();
    }

    setData(propType: REWARD_TYPE, propNumber: number) {
        this.m_propType = propType;
        this.m_propCount = propNumber;
    }

    private m_propType: REWARD_TYPE = null;
    private m_propCount: number = null;

    protected initView() {
        if (this.m_propType == null) {
            console.error('#505131 添加用户道具错误');
            return;
        }
        //出场动画
        // modules().uiControlModule.showHideDialogAnimation(this.detail, true);
        //
        this.showNum.string = `×${data_control.getNumberFormat(this.m_propCount)}`;
        this.spIcon.spriteFrame = this.spfIcons[this.m_propType];
        this.title.string = ['获取金币', '获取体力', '获取钻石'][this.m_propType];

    }

    protected onBtnClose() {
        // modules().uiControlModule.showHideDialogAnimation(this.detail, false, () => {
        //     this.node.destroy();
        // });
        this.ClosePage();
    }

    protected onBtnGet(e:cc.Event.EventTouch) {
        let lookString = '未定义获取道具说明';
        let lookOverFunction: () => void = null;
        let rewardType: REWARD_TYPE = null;
        switch (this.m_propType) {
            case REWARD_TYPE.COIN: {
                lookOverFunction = () => {
                    services().userSrv.setCoins(this.m_propCount, true,e.target);
                }
                rewardType = REWARD_TYPE.COIN;
                lookString = '获取金币';
                break;
            }
            case REWARD_TYPE.POWER: {
                lookOverFunction = () => {
                    services().userSrv.addPowerOfVideo();
                }
                rewardType = REWARD_TYPE.POWER;
                lookString = '获取体力';
                break;
            }
            case REWARD_TYPE.DIAMOND: {
                lookOverFunction = () => {
                    services().userSrv.addDiamondOfVideo();
                    // console.warn('#841801 钻石未定义');
                }
                rewardType = REWARD_TYPE.DIAMOND;
                lookString = '获取钻石';
                break;
            }
            default: {
                throw '#900224 未知定义道具';
            }
        }
        //查看视频
        utilsModel.loadAndShowVideoAdTrans(() => {
            lookOverFunction();
            //
            modules().uiControlModule.showGetRewarded(rewardType, this.m_propCount);
        }, null, null, lookString);
    }
}
